@if (!!actionInput) {
  @if (!(actionInput.type === 'two_way' && !twoWayService.showTwoWay())) {
    <div
      class="action-link row"
      >
      <!-- Disable move up/down or remove for disclaimer action -->
      @if (actionInput.type !== 'disclaimer') {
        <div class="col-12">
          <label>{{ labelHeader }}</label>
          <div class="pull-right">
            @if (canMoveUp) {
              <i
                class="fa fa-arrow-circle-up message-action"
                aria-hidden="true"
                (click)="moveActionUp()"
                id="move-action-up-{{ i }}"
              ></i>
            }
            @if (canMoveDown) {
              <i
                class="fa fa-arrow-circle-down message-action"
                aria-hidden="true"
                (click)="moveActionDown()"
                id="move-action-down-{{ i }}"
              ></i>
            }
            <i
              class="fa fa-minus-circle message-action"
              aria-hidden="true"
              (click)="deleteAction()"
              id="delete-action-{{ i }}"
            ></i>
            @if (
              actionInput.type === 'plaid' &&
              featureService.checkFlag(featureFlags.plaid_integration)
              ) {
              <i
                class="fa fa-money"
              ></i>
            }
          </div>
        </div>
      }
      @if (actionInput.type !== 'disclaimer') {
        <div class="col-sm-2 actions">
          <!-- .btn-inactive will disable all kinds of events on this div -->
          <div class="btn btn-lg btn-primary btn-inactive">
            @if (actionInput.type === 'hyperlink') {
              <i
                class="fa fa-link"
                aria-hidden="true"
              ></i>
            }
            @if (actionInput.type === 'collapsible') {
              <i
                class="fa re-collapsible"
                aria-hidden="true"
              ></i>
            }
            @if (actionInput.type === 'call') {
              <i
                class="fa fa-phone"
                aria-hidden="true"
              ></i>
            }
            @if (actionInput.type === 'email') {
              <img
                src="/assets/icons/icon-EmailAction.png"
                />
            }
            @if (actionInput.type === 'message') {
              <i
                class="fa fa-code-fork turn90"
                aria-hidden="true"
              ></i>
            }
            @if (actionInput.type === 'consent_upgrade') {
              <i
                class="fa fa-angle-double-up"
                aria-hidden="true"
              ></i>
            }
            @if (actionInput.type === 'two_way' && twoWayService.showTwoWay()) {
              <i
                class="fa fa-comments"
                aria-hidden="true"
              ></i>
            }
            @if (
              actionInput.type === 'plaid' &&
              featureService.checkFlag(featureFlags.plaid_integration)
              ) {
              <i
                class="fa fa-money"
              ></i>
            }
            @if (
              actionInput.type === 'apple_chat' &&
              featureService.checkFlag(featureFlags.apple_chat)
              ) {
              <i
                class="fa fa-apple"
              ></i>
            }
            @if (
              actionInput.type === 'form_info_capture'
              ) {
              <i
                class="fa fa-wpforms"
              ></i>
            }
            @if (actionInput.type === 'contact_card') {
              <i
                class="fa-regular fa-address-card"
                aria-hidden="true"
              ></i>
            }
          </div>
        </div>
      }
      @if (actionInput.type === 'hyperlink') {
        <div class="col-sm-10">
          <div class="row">
            <label class="col-sm-3 form-label">Label</label>
            <div
              class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
              >

              <input
                [mention]="dynamicInputs"
                [mentionConfig]="mentionConfig"
                name="action-link-label-{{ i }}"
                class="form-control action-link-label"
                type="text"
                [formControl]="formReference.controls['label']"
                dir="auto"
                />
              <app-error-display
                [control]="formReference.controls['label']"
                [customErrorMessageProvider]="getTooltipData.bind(this)"
                [showCharacterCount]="newFeed.enabled"
                [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                [currentLength]="actionInput.label.length">
              </app-error-display>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 form-label">URL</label>
            <div
              class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['value']?.valid &&
                formReference.controls['value']?.touched
            }"
              >

              <input
                [mention]="dynamicInputs"
                [mentionConfig]="mentionConfig"
                name="action-link-value-{{ i }}"
                class="form-control action-link-value"
                type="url"
                (blur)="formatUrl(formReference.controls['value'])"
                [formControl]="formReference.controls['value']"
                spellcheck="false"
                />
              <app-error-display
                [control]="formReference.controls['value']"
                [customErrorMessageProvider]="getTooltipData.bind(this)">
              </app-error-display>
            </div>
          </div>
          <div class="row clearfix">
            <div class="col-sm-9 offset-3 checkbox-container">
              <rn-checkbox
                [inputName]="'action-link-open-in-new-tab-' + i"
                [checkboxModel]="openInNewTabFrmCtl.value"
              (checkboxModelChange)="
                openInNewTabFrmCtl.patchValue(!openInNewTabFrmCtl.value)
              "
                >
              </rn-checkbox>
              <label class="form-label p-0">Open URL in new tab</label>
            </div>
            @if (fdicEnabled) {
              <div class="col-sm-9 offset-3 checkbox-container">
                <rn-checkbox
                  [inputName]="'action-link-non-deposit-popup-enabled-' + i"
                  [checkboxModel]="nonDepositPopUpEnabledCtl.value"
              (checkboxModelChange)="
                nonDepositPopUpEnabledCtl.patchValue(
                  !nonDepositPopUpEnabledCtl.value
                )
              "
                  >
                </rn-checkbox>
                <label class="form-label p-0">Add non deposit popup</label>
              </div>
            }
          </div>
        </div>
      }
      @if (actionInput.type === 'collapsible') {
        <div class="col-sm-10">
          <div class="row action-collapsible">
            <label class="col-sm-3 form-label">Label</label>
            <div
              class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
              >
              <input
                mentionInput
                [mention]="dynamicInputs"
                [mentionConfig]="mentionConfig"
                name="action-collapsible-label-{{ i }}"
                class="form-control action-collapsible-label"
                type="text"
                [formControl]="formReference.controls['label']"
                dir="auto"
                />
              <app-error-display
                [control]="formReference.controls['label']"
                [customErrorMessageProvider]="getTooltipData.bind(this)"
                [showCharacterCount]="newFeed.enabled"
                [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                [currentLength]="actionInput.label.length">
              </app-error-display>
            </div>
          </div>
        </div>
        <div
          class="col-sm-12"
        [ngClass]="{
          'has-error':
            !formReference.controls['value']?.valid &&
            formReference.controls['value']?.touched
        }"
          >
          <label style="visibility: hidden">Collapsible Text</label>
          <app-error-display
            [control]="formReference.controls['value']"
            [customErrorMessageProvider]="getTooltipData.bind(this)">
          </app-error-display>
          <!-- TODO: use reactive or template forms - not both. See: https://angular.io/api/forms/FormControlDirective#use-with-ngmodel -->
          <app-tiny-editor
            [attr.name]="'action-collapsible-value-' + i"
            class="tiny-editor-mentions action-collapsible-value"
            [elementId]="'tiny-editor-action-collapsible-value-' + i"
            [formControl]="formReference.controls['value']"
            [config]="tinyEditorConfig"
            >
          </app-tiny-editor>
        </div>
      }
      @if (actionInput.type === 'call') {
        <div class="col-sm-10">
          <div class="row">
            <label class="col-sm-3 form-label action">Label</label>
            <div
              class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
              >
              <input
                disableAutoComplete
                [mention]="dynamicInputs"
                [mentionConfig]="mentionConfig"
                name="action-call-label-{{ i }}"
                class="form-control action-call-label"
                type="text"
                [formControl]="formReference.controls['label']"
                dir="auto"
                />
              <app-error-display
                [control]="formReference.controls['label']"
                [customErrorMessageProvider]="getTooltipData.bind(this)"
                [showCharacterCount]="newFeed.enabled"
                [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                [currentLength]="actionInput.label.length">
              </app-error-display>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 form-label">Phone #</label>
            <div
              class="col-sm-9"
            [class.has-error]="
              !formReference.controls['value']?.valid &&
              formReference.controls['value']?.touched
            "
              >
              <input
                disableAutoComplete
                [mention]="dynamicInputs"
                [mentionConfig]="mentionConfig"
                name="action-call-value-{{ i }}"
                class="form-control action-call-value"
                type="tel"
                (blur)="formatPhoneNumber(formReference.controls['value'])"
                [formControl]="formReference.controls['value']"
                />
              <app-error-display
                [control]="formReference.controls['value']"
                [customErrorMessageProvider]="getTooltipData.bind(this)">
              </app-error-display>
            </div>
          </div>
        </div>
      }
      @if (actionInput.type === 'email') {
        <div class="col-sm-10">
          <div class="row">
            <label class="col-sm-3 form-label action">Label</label>
            <div
              class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
              >
              <input
                disableAutoComplete
                [mention]="dynamicInputs"
                [mentionConfig]="mentionConfig"
                name="action-email-label-{{ i }}"
                class="form-control action-email-label"
                type="text"
                [formControl]="formReference.controls['label']"
                dir="auto"
                />
              <app-error-display
                [control]="formReference.controls['label']"
                [customErrorMessageProvider]="getTooltipData.bind(this)"
                [showCharacterCount]="newFeed.enabled"
                [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                [currentLength]="actionInput.label.length">
              </app-error-display>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 form-label">Email</label>
            <div
              class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['value']?.valid &&
                formReference.controls['value']?.touched
            }"
              >
              <input
                disableAutoComplete
                [mention]="getItems(actionInput.value)"
                [mentionConfig]="mentionConfig"
                name="action-email-value-{{ i }}"
                class="form-control action-email-value"
                type="text"
                [formControl]="formReference.controls['value']"
                />
              <app-error-display
                [control]="formReference.controls['value']"
                [customErrorMessageProvider]="getTooltipData.bind(this)">
              </app-error-display>
            </div>
          </div>
        </div>
      }
      @if (actionInput.type === 'message') {
        <div class="col-sm-10">
          <div class="row">
            <label class="col-sm-3 form-label action">Label</label>
            <div
              class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
              >
              <input
                name="action-message-label-{{ i }}"
                class="form-control action-message-label"
                type="text"
                (blur)="bindNickname(actionInput)"
                [mention]="dynamicInputs"
                [mentionConfig]="mentionConfig"
                [formControl]="formReference.controls['label']"
                dir="auto"
                />
              <app-error-display
                [control]="formReference.controls['label']"
                [customErrorMessageProvider]="getTooltipData.bind(this)"
                [showCharacterCount]="newFeed.enabled"
                [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                [currentLength]="actionInput.label.length">
              </app-error-display>
            </div>
          </div>
        </div>
      }
      @if (actionInput.type === 'consent_upgrade' && productGroup) {
        <div class="col-sm-10">
          <div class="row">
            <label class="col-sm-3 form-label action">Label</label>
            <div
              class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
              >
              <input
                mentionInput
                [mention]="dynamicInputs"
                [mentionConfig]="mentionConfig"
                name="iwcu-label-{{ i }}"
                class="form-control action-iwcu-label"
                type="text"
                [formControl]="formReference.controls['label']"
                dir="auto"
                />
              <app-error-display
                [control]="formReference.controls['label']"
                [customErrorMessageProvider]="getTooltipData.bind(this)"
                [showCharacterCount]="newFeed.enabled"
                [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                [currentLength]="actionInput.label.length">
              </app-error-display>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          @if (newFeed.enabled && !actionInput.primary) {
            <p>
              NOTE: Consent upgrade will be embedded within the message by default.
              If you wish to open it in a separate window instead, please check the
              box below.
            </p>
          }
          @if (newFeed.enabled && actionInput.primary) {
            <p>
              NOTE: Consent upgrade will open in a separate window
            </p>
          }
        </div>
        <div class="col-sm-10">
          @if (newFeed.enabled && !actionInput.primary) {
            <div
              class="row clearfix"
              >
              <div class="col-sm-10 offset-4 checkbox-container">
                <rn-checkbox
                  [inputName]="'action-consent-upgrade-within-card-' + i"
                  [checkboxModel]="openConsentTCsFrmCtl.value"
              (checkboxModelChange)="
                openConsentTCsFrmCtl.patchValue(!openConsentTCsFrmCtl.value)
              "
                  matTooltip="Only recommended for forms that contain four or fewer questions per page"
                  matTooltipPosition="left"
                  >
                </rn-checkbox>
                <label class="form-label"
                  >Open consent upgrade in a separate window</label
                  >
                </div>
              </div>
            }
          </div>
          @if (journey.draft.product_group !== 'all') {
            <div class="col-sm-12">
              <div
          [ngClass]="{
            'has-error':
              !formReference.controls['value']?.valid &&
              formReference.controls['value']?.touched
          }"
                >
                <label>{{
                  newFeed.enabled
                  ? 'Consent Upgrade Ts&Cs'
                  : 'In Wire Consent Upgrade Ts&Cs'
                }}</label>

                <app-error-display
                  [control]="formReference.controls['value']"
                  [customErrorMessageProvider]="getTooltipData.bind(this)">
                </app-error-display>
                <div>
                  <p
              [innerHtml]="
                (journey.latestContent?.language === 'es' ? productGroup?.i18n?.es?.translations?.consent?.in_wire_upgrade || '' : productGroup.consent.in_wire_upgrade.ts_cs) | safeHtml
              "
                  ></p>
                  <span
                    >Terms & Conditions text is set globally within client
                    configuration</span
                    >
                  </div>
                </div>
              </div>
            }
            @if (journey.draft.product_group === 'all') {
              <div class="row">
                <div class="col-sm-12">
                  <label
                    >Terms and Conditions will show for the user's default product
                    group</label
                    >
                  </div>
                </div>
              }
            }
            @if (actionInput.type === 'contact_card') {
              <div class="col-sm-10">
                <div class="row">
                  <label class="col-sm-3 form-label action">Label</label>
                  <div
                    class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
                    >
                    <input
                      disableAutoComplete
                      [mention]="dynamicInputs"
                      [mentionConfig]="mentionConfig"
                      name="action-contact-card-label-{{ i }}"
                      class="form-control action-contact-card-label"
                      type="text"
                      [formControl]="formReference.controls['label']"
                      dir="auto"
                      />
                    <app-error-display
                      [control]="formReference.controls['label']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)"
                      [showCharacterCount]="newFeed.enabled"
                      [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                      [currentLength]="actionInput.label.length">
                    </app-error-display>
                  </div>
                </div>
              </div>
            }
            @if (actionInput.type === 'two_way' && twoWayService.showTwoWay()) {
              <div class="col-sm-10">
                <div class="row">
                  <label class="col-sm-3 form-label action">Label</label>
                  <div
                    class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
                    >
                    <input
                      name="action-message-label-{{ i }}"
                      class="form-control action-two-way-label"
                      type="text"
                      [mention]="dynamicInputs"
                      [mentionConfig]="mentionConfig"
                      [formControl]="formReference.controls['label']"
                      dir="auto"
                      />
                    <app-error-display
                      [control]="formReference.controls['label']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)"
                      [showCharacterCount]="newFeed.enabled"
                      [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                      [currentLength]="actionInput.label.length">
                    </app-error-display>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-3 form-label action">Tag Value</label>
                  <div
                    class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['value']?.valid &&
                formReference.controls['value']?.touched
            }"
                    >

                    @if (!twoWayTags) {
                      <app-spinner></app-spinner>
                    }
                    @if (twoWayTags) {
                      <select
                        class="form-control"
                        name="action-message-value-{{ i }}"
                        [formControl]="formReference.controls['value']"
                        >
                        <option value="">Select</option>
                        @for (tag of twoWayTags; track tag) {
                          <option [ngValue]="tag.tag_id">
                            {{ tag.tag_name }}
                          </option>
                        }
                      </select>
                    }
                    <app-error-display
                      [control]="formReference.controls['value']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)">
                    </app-error-display>
                  </div>
                </div>
              </div>
            }
            @if (actionInput.type === 'plaid') {
              <div class="col-sm-10">
                <div class="row">
                  <label class="col-sm-3 form-label action">Label</label>
                  <div
                    class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
                    >
                    <input
                      name="action-plaid-label-{{ i }}"
                      class="form-control"
                      type="text"
                      [mention]="dynamicInputs"
                      [mentionConfig]="mentionConfig"
                      [formControl]="formReference.controls['label']"
                      dir="auto"
                      />
                    <app-error-display
                      [control]="formReference.controls['label']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)"
                      [showCharacterCount]="newFeed.enabled"
                      [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                      [currentLength]="actionInput.label.length">
                    </app-error-display>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-3 form-label action">Header</label>
                  <div
                    class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['disclaimer_header']?.valid &&
                formReference.controls['disclaimer_header']?.touched
            }"
                    >

                    <input
                      name="action-plaid-header-{{ i }}"
                      class="form-control"
                      type="text"
                      [mention]="dynamicInputs"
                      [mentionConfig]="mentionConfig"
                      [formControl]="formReference.controls['disclaimer_header']"
                      />
                    <app-error-display
                      [control]="formReference.controls['disclaimer_header']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)">
                    </app-error-display>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-3 form-label action">Body</label>
                  <div class="col-sm-9">

                    <textarea
                      name="action-plaid-body-{{ i }}"
                      cols="30"
                      rows="10"
                      class="form-control"
                      [mention]="dynamicInputs"
                      [mentionConfig]="mentionConfig"
                      [formControl]="formReference.controls['disclaimer_body']"
                    ></textarea>
                    <app-error-display
                      [control]="formReference.controls['disclaimer_body']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)">
                    </app-error-display>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-3 form-label action">Accept Label</label>
                  <div class="col-sm-9">

                    <input
                      name="action-plaid-accept-{{ i }}"
                      class="form-control"
                      type="text"
                      [mention]="dynamicInputs"
                      [mentionConfig]="mentionConfig"
                      [formControl]="formReference.controls['disclaimer_check_label']"
                      />
                    <app-error-display
                      [control]="formReference.controls['disclaimer_check_label']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)">
                    </app-error-display>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-3 form-label action">Submit Label</label>
                  <div class="col-sm-9">

                    <input
                      name="action-plaid-submit-{{ i }}"
                      class="form-control"
                      type="text"
                      [mention]="dynamicInputs"
                      [mentionConfig]="mentionConfig"
                      [formControl]="formReference.controls['disclaimer_submit_label']"
                      />
                    <app-error-display
                      [control]="formReference.controls['disclaimer_submit_label']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)">
                    </app-error-display>
                  </div>
                </div>
              </div>
            }
            @if (
              actionInput.type === 'apple_chat' &&
              featureService.checkFlag(featureFlags.apple_chat)
              ) {
              <div class="col-sm-10">
                <div class="row">
                  <label class="col-sm-3 form-label action">Label</label>
                  <div
                    class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
                    >
                    <input
                      name="action-label-{{ i }}"
                      class="form-control"
                      type="text"
                      [mention]="dynamicInputs"
                      [mentionConfig]="mentionConfig"
                      [formControl]="formReference.controls['label']"
                      dir="auto"
                      />
                    <app-error-display
                      [control]="formReference.controls['label']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)"
                      [showCharacterCount]="newFeed.enabled"
                      [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                      [currentLength]="actionInput.label.length">
                    </app-error-display>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-3 form-label action">Phone</label>
                  <div
                    class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['apple_chat_phone']?.valid &&
                formReference.controls['apple_chat_phone']?.touched
            }"
                    >

                    <input
                      name="action-apple_chat_phone-{{ i }}"
                      class="form-control"
                      type="text"
                      [mention]="dynamicInputs"
              (blur)="
                formatPhoneNumber(formReference.controls['apple_chat_phone'])
              "
                      [mentionConfig]="mentionConfig"
                      [formControl]="formReference.controls['apple_chat_phone']"
                      />
                    <app-error-display
                      [control]="formReference.controls['apple_chat_phone']"
                      [customErrorMessageProvider]="getTooltipData.bind(this)">
                    </app-error-display>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-3 form-label action"
                    >Business ID (optional)</label
                    >
                    <div
                      class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['apple_chat_business_id']?.valid &&
                formReference.controls['apple_chat_business_id']?.touched
            }"
                      >

                      <input
                        name="action-apple_chat_business_id-{{ i }}"
                        class="form-control"
                        type="text"
                        [mention]="dynamicInputs"
                        [mentionConfig]="mentionConfig"
                        [formControl]="formReference.controls['apple_chat_business_id']"
                        />
                      <app-error-display
                        [control]="formReference.controls['apple_chat_business_id']"
                        [customErrorMessageProvider]="getTooltipData.bind(this)">
                      </app-error-display>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-sm-3 form-label action"
                      >Business Intent (optional)</label
                      >
                      <div
                        class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['apple_chat_biz_intent_id']?.valid &&
                formReference.controls['apple_chat_biz_intent_id']?.touched
            }"
                        >

                        <input
                          name="action-apple_chat_biz_intent_id-{{ i }}"
                          class="form-control"
                          type="text"
                          [mention]="dynamicInputs"
                          [mentionConfig]="mentionConfig"
                          [formControl]="formReference.controls['apple_chat_biz_intent_id']"
                          />
                        <app-error-display
                          [control]="formReference.controls['apple_chat_biz_intent_id']"
                          [customErrorMessageProvider]="getTooltipData.bind(this)">
                        </app-error-display>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-3 form-label action"
                        >Business Group (optional)</label
                        >
                        <div
                          class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['apple_chat_biz_group_id']?.valid &&
                formReference.controls['apple_chat_biz_group_id']?.touched
            }"
                          >

                          <input
                            name="action-apple_chat_biz_group_id-{{ i }}"
                            class="form-control"
                            type="text"
                            [mention]="dynamicInputs"
                            [mentionConfig]="mentionConfig"
                            [formControl]="formReference.controls['apple_chat_biz_group_id']"
                            />
                          <app-error-display
                            [control]="formReference.controls['apple_chat_biz_group_id']"
                            [customErrorMessageProvider]="getTooltipData.bind(this)">
                          </app-error-display>
                        </div>
                      </div>
                      <div class="row">
                        <label class="col-sm-3 form-label action">Body (optional)</label>
                        <div
                          class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['apple_chat_body']?.valid &&
                formReference.controls['apple_chat_body']?.touched
            }"
                          >

                          <input
                            name="action-apple_chat_body-{{ i }}"
                            class="form-control"
                            type="text"
                            [mention]="dynamicInputs"
                            [mentionConfig]="mentionConfig"
                            [formControl]="formReference.controls['apple_chat_body']"
                            />
                          <app-error-display
                            [control]="formReference.controls['apple_chat_body']"
                            [customErrorMessageProvider]="getTooltipData.bind(this)">
                          </app-error-display>
                        </div>
                      </div>
                    </div>
                  }
                  @if (
                    actionInput.type === 'form_info_capture'
                    ) {
                    <div class="col-sm-10">
                      <div class="row">
                        <label class="col-sm-3 form-label">Label</label>
                        <div
                          class="col-sm-9"
            [ngClass]="{
              'has-error':
                !formReference.controls['label']?.valid &&
                formReference.controls['label']?.touched
            }"
                          >

                          <input
                            [mention]="dynamicInputs"
                            [mentionConfig]="mentionConfig"
                            name="action-form-info-capture-label-{{ i }}"
                            class="form-control action-form-info-capture-label"
                            type="text"
                            [formControl]="formReference.controls['label']"
                            dir="auto"
                            />
                          <app-error-display
                            [control]="formReference.controls['label']"
                            [customErrorMessageProvider]="getTooltipData.bind(this)"
                            [showCharacterCount]="newFeed.enabled"
                            [maxLength]="getPrimarySecondaryCharLimit(actionInput)"
                            [currentLength]="actionInput.label.length">
                          </app-error-display>
                        </div>
                      </div>
                      @if (newFeed.enabled) {
                        <div class="row clearfix">
                          <div class="col-sm-9 offset-3 checkbox-container">
                            <rn-checkbox
                              [inputName]="'action-powerups-open-within-card-' + i"
                              [checkboxModel]="openWithinMessageFrmCtl.value"
              (checkboxModelChange)="
                openWithinMessageFrmCtl.patchValue(
                  !openWithinMessageFrmCtl.value
                )
              "
                              matTooltip="Only recommended for forms that contain four or fewer questions per page"
                              matTooltipPosition="left"
                              >
                            </rn-checkbox>
                            <label class="form-label">Embed Power-Up form within message</label>
                          </div>
                        </div>
                      }
                      <div class="row clearfix">
                        <div class="col-sm-9 offset-3 checkbox-container">
                          <rn-checkbox
                            [inputName]="'action-powerups-suppress-duplicate-submissions-' + i"
                            [checkboxModel]="suppressDuplicateSubmissionsFrmCtl.value"
              (checkboxModelChange)="
                suppressDuplicateSubmissionsFrmCtl.patchValue(
                  !suppressDuplicateSubmissionsFrmCtl.value
                )
              "
                            matTooltip="Blocks the same recipient from submitting this form more than once per delivered message."
                            matTooltipPosition="left"
                            >
                          </rn-checkbox>
                          <label class="form-label">Suppress duplicate submissions</label>
                        </div>
                      </div>
                      <div class="row">
                        <rn-power-ups-action
                          [formReference]="formReference"
                        ></rn-power-ups-action>
                      </div>
                    </div>
                  }
                  @if (actionInput.type === 'disclaimer') {
                    <div
        [ngClass]="{
          'has-error':
            !formReference.controls['value']?.valid &&
            formReference.controls['value']?.touched
        }"
                      class="col-12"
                      >
                      <app-error-display
                        [control]="formReference.controls['value']"
                        [customErrorMessageProvider]="getTooltipData.bind(this)">
                      </app-error-display>
                      <app-tiny-editor
                        [attr.name]="'action-disclaimer-value-' + i"
                        class="tiny-editor-mentions action-disclaimer-value"
                        [elementId]="'tiny-editor-action-disclaimer-value-' + i"
                        [formControl]="formReference.controls['value']"
                        >
                      </app-tiny-editor>
                    </div>
                  }
                </div>
              }
            }
